import angular from "angular";
import "./localSearchAnalyticsController";
angular.module('clientDashboardApp.localSearchAnalytics', []);
